<!-- Renders nothing at all while there is no second book: no screen grows an empty section on a
     single-currency terminal, which is every terminal until ZiG is switched on. -->
<ng-container *ngIf="shows || awaitingRecord || loadError">
  <div class="separator separator-dashed my-8"></div>

  <h3 class="text-dark fw-bold fs-6 mb-1">{{ heading }}</h3>
  <p class="text-gray-700 fs-8 mb-4">
    Typed here or on the central Price List — they are the same price, not two copies of it. A charge with no
    price in the currency it is settled in is <strong class="text-dark">refused</strong>; there is no exchange
    rate anywhere in this system.
  </p>

  <!-- A record that does not exist yet cannot hold a price row, because the row is keyed by its reference. -->
  <div class="alert alert-light border border-dashed fs-8" *ngIf="awaitingRecord">
    Save this record first, then its prices in other currencies can be typed here.
  </div>

  <div class="alert alert-danger d-flex align-items-center fs-8" *ngIf="loadError">
    <i class="bi bi-exclamation-triangle-fill me-2"></i>
    <span class="flex-grow-1">{{ loadError }}</span>
    <button type="button" class="btn btn-sm btn-light fw-bold ms-3" (click)="load()">Try again</button>
  </div>

  <div class="table-responsive" *ngIf="prices && !loading && shows">
    <table class="table align-middle table-row-dashed fs-8 no-footer">
      <thead>
        <tr class="text-start text-gray-800 fs-8 text-uppercase">
          <th class="pb-3 fw-bold">Charge</th>
          <th class="pb-3 fw-bold text-end">{{ prices.base }} · on the record</th>
          <th class="pb-3 fw-bold text-end" *ngFor="let book of otherBooks">{{ book }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let field of prices.fields">
          <td class="fw-bold text-dark">{{ label(field) }}</td>
          <!-- The base figure, read-only: it is edited on this record's own form, above. -->
          <td class="text-end text-gray-700">
            <span *ngIf="baseAmount(field) !== null">
              {{ baseAmount(field) | number : '1.2-2' }} <span class="fw-bold">{{ prices.base }}</span>
            </span>
            <span *ngIf="baseAmount(field) === null">no charge</span>
          </td>
          <td class="text-end" *ngFor="let book of otherBooks">
            <!-- The book sits ON the figure, as the $ does on the record's own price field above. A number
                 alone in a column headed ZIG is read as dollars often enough to matter, and this is the
                 field that decides what a client is charged. -->
            <div class="d-flex align-items-center justify-content-end">
              <div class="input-group input-group-sm" style="max-width: 190px">
                <span class="input-group-text fw-bold">{{ book }}</span>
                <input type="number" min="0" step="0.01"
                  class="form-control form-control-sm form-control-solid text-end"
                  [(ngModel)]="drafts[key(field, book)]" [name]="key(field, book)"
                  [disabled]="saving[key(field, book)]"
                  placeholder="no price"
                  (keydown.enter)="onEnter($event, field, book)" />
              </div>
              <button type="button" class="btn btn-sm btn-light fw-bold ms-2"
                [disabled]="saving[key(field, book)]" (click)="save(field, book)">
                {{ saving[key(field, book)] ? '…' : 'Save' }}
              </button>
              <!-- An empty box is refused: "no charge" bills zero, so it is a decision with its own button (#54),
                   as on the central Price List. -->
              <button type="button" class="btn btn-sm btn-light fw-bold ms-2"
                [disabled]="saving[key(field, book)]"
                title="Record that this charge does not apply here. It will bill zero in {{ book }}."
                (click)="saveNoCharge(field, book)">No charge</button>
            </div>
            <!-- A recorded "no charge" must be impossible to mistake for a missing price: the empty box alone
                 reads "no price". -->
            <div class="text-gray-600 fs-8 mt-1" *ngIf="isNoCharge(field, book) && !cellError[key(field, book)]">
              no charge — bills zero in {{ book }}
            </div>
            <!-- A charge the base bills for that this book cannot price REFUSES that charge outright. -->
            <div class="text-danger fs-8 mt-1" *ngIf="blocks(field, book) && !cellError[key(field, book)]">
              <i class="bi bi-exclamation-circle-fill me-1"></i>no price — this charge is refused in {{ book }}
            </div>
            <div class="text-success fs-8 mt-1" *ngIf="saved[key(field, book)] && !cellError[key(field, book)]">
              saved
            </div>
            <!-- VERBATIM: a refused retype names what must be settled first. -->
            <div class="text-danger fs-8 mt-1 text-start" *ngIf="cellError[key(field, book)]">
              {{ cellError[key(field, book)] }}
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="text-gray-700 fs-8 py-3" *ngIf="loading">Loading prices…</div>
</ng-container>
